(function () {
  'use strict';

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function key(value) {
    return cleanText(value).toLocaleLowerCase('es');
  }

  function pathOf(url) {
    try {
      var path = new URL(url, window.location.origin).pathname.replace(/\/+$/, '');
      return path || '/';
    } catch (e) {
      return '';
    }
  }

  function directChildByClass(parent, className) {
    if (!parent) return null;
    for (var i = 0; i < parent.children.length; i += 1) {
      if (parent.children[i].classList.contains(className)) return parent.children[i];
    }
    return null;
  }

  function enhanceSidebar() {
    var megaList = document.querySelector('#_desktop_top_menu .sb-mega-root-list');
    var sidebar = document.querySelector('.sidebar-categories .categories-menu');
    if (!megaList || !sidebar || sidebar.getAttribute('data-sb-three-level') === 'true') return;

    var sourceRoots = {};
    Array.prototype.forEach.call(megaList.children, function (root) {
      if (!root.classList.contains('sb-mega-root-item')) return;
      var rootLink = directChildByClass(root, 'sb-mega-root-link');
      if (!rootLink) return;
      var titleNode = rootLink.querySelector('.title');
      sourceRoots[key(titleNode ? titleNode.textContent : rootLink.textContent)] = root;
    });

    var currentPath = window.location.pathname.replace(/\/+$/, '') || '/';

    Array.prototype.forEach.call(sidebar.querySelectorAll('.categories-items'), function (panel, panelIndex) {
      var titleLink = panel.querySelector('.panel-heading .panel-title > a:not(.collapse-icon)');
      if (!titleLink) return;

      var sourceRoot = sourceRoots[key(titleLink.textContent)];
      if (!sourceRoot) return;

      var target = panel.querySelector('.panel-collapse');
      var grid = sourceRoot.querySelector('.sb-mega-grid');
      if (!target || !grid) return;

      var groups = document.createElement('div');
      groups.className = 'sb-sidebar-groups';
      var rootContainsCurrent = false;

      Array.prototype.forEach.call(grid.children, function (sourceGroup, groupIndex) {
        if (!sourceGroup.classList.contains('sb-mega-column')) return;

        var sourceGroupLink = sourceGroup.querySelector('.sb-mega-group-link');
        if (!sourceGroupLink) return;

        var group = document.createElement('div');
        group.className = 'sb-sidebar-group';

        var groupHead = document.createElement('div');
        groupHead.className = 'sb-sidebar-group-head';

        var groupLink = document.createElement('a');
        groupLink.className = 'sb-sidebar-group-link';
        groupLink.href = sourceGroupLink.href;
        var sourceGroupTitle = sourceGroupLink.querySelector('.inner-title');
        groupLink.textContent = cleanText(sourceGroupTitle ? sourceGroupTitle.textContent : sourceGroupLink.textContent);
        groupHead.appendChild(groupLink);

        var sourceLeaves = sourceGroup.querySelectorAll('.sb-mega-leaf-item > a');
        var leafList = null;
        var groupContainsCurrent = pathOf(groupLink.href) === currentPath;

        if (sourceLeaves.length) {
          var toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'sb-sidebar-group-toggle';
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-label', 'Mostrar subcategorías de ' + groupLink.textContent);
          groupHead.appendChild(toggle);

          leafList = document.createElement('div');
          leafList.className = 'sb-sidebar-leaf-list';
          leafList.id = 'sb-sidebar-leaves-' + panelIndex + '-' + groupIndex;
          toggle.setAttribute('aria-controls', leafList.id);

          Array.prototype.forEach.call(sourceLeaves, function (sourceLeaf) {
            var leafLink = document.createElement('a');
            leafLink.className = 'sb-sidebar-leaf-link';
            leafLink.href = sourceLeaf.href;
            leafLink.textContent = cleanText(sourceLeaf.textContent);
            if (pathOf(leafLink.href) === currentPath) {
              leafLink.classList.add('is-current');
              groupContainsCurrent = true;
            }
            leafList.appendChild(leafLink);
          });

          toggle.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            var open = group.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
        }

        if (groupContainsCurrent) {
          group.classList.add('is-current');
          rootContainsCurrent = true;
          if (sourceLeaves.length) {
            group.classList.add('is-open');
            var currentToggle = groupHead.querySelector('.sb-sidebar-group-toggle');
            if (currentToggle) currentToggle.setAttribute('aria-expanded', 'true');
          }
        }

        group.appendChild(groupHead);
        if (leafList) group.appendChild(leafList);
        groups.appendChild(group);
      });

      target.innerHTML = '';
      target.classList.add('sb-sidebar-level2');
      target.appendChild(groups);

      if (rootContainsCurrent) {
        panel.classList.add('sb-sidebar-current-root');
      }
    });

    sidebar.setAttribute('data-sb-three-level', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceSidebar);
  } else {
    enhanceSidebar();
  }

  window.addEventListener('pageshow', enhanceSidebar);
}());

/* Smart Business — adaptación móvil Warehouse para colección y búsqueda. */
(function () {
  'use strict';

  var mobileMedia = window.matchMedia('(max-width: 991px)');
  var scriptSource = document.currentScript && document.currentScript.src;
  var scheduled = false;
  var observer = null;

  function ensureWarehouseStyles() {
    if (document.getElementById('sb-mobile-warehouse-styles') || !scriptSource) return;

    var stylesheet = document.createElement('link');
    stylesheet.id = 'sb-mobile-warehouse-styles';
    stylesheet.rel = 'stylesheet';
    stylesheet.href = new URL('sb-mobile-warehouse.css?v=20260830-2', scriptSource).href;
    document.head.appendChild(stylesheet);
  }

  function isCollectionExperience() {
    return document.body.classList.contains('template-collection') ||
      document.body.classList.contains('template-search') ||
      Boolean(document.getElementById('ProductGridContainer'));
  }

  function funnelIcon() {
    return '<svg class="sb-filter-funnel" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M3 5h18l-7 8v5.5l-4 2V13L3 5Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"></path>' +
      '</svg>';
  }

  function caretIcon() {
    return '<svg class="sb-mobile-sort-caret" viewBox="0 0 12 8" aria-hidden="true" focusable="false">' +
      '<path d="m1 1.25 5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg>';
  }

  function enhanceFilterButton(toolbar) {
    var button = toolbar.querySelector('.mobile-facets__open');
    if (!button) return;

    var icon = button.querySelector('svg');
    if (!icon || !icon.classList.contains('sb-filter-funnel')) {
      if (icon) {
        icon.outerHTML = funnelIcon();
      } else {
        button.insertAdjacentHTML('afterbegin', funnelIcon());
      }
    }

    var textNodes = button.querySelectorAll('span');
    for (var i = 0; i < textNodes.length; i += 1) {
      if (!textNodes[i].classList.contains('count-bubble') &&
          !textNodes[i].closest('.count-bubble')) {
        if (textNodes[i].textContent.trim() !== 'Filtro') {
          textNodes[i].textContent = 'Filtro';
        }
        break;
      }
    }
  }

  function buildMobileSort(toolbar) {
    if (toolbar.querySelector('.sb-mobile-sort')) return;

    var source = toolbar.querySelector('#SortBy-mobile') || toolbar.querySelector('#SortBy');
    if (!source) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'sb-mobile-sort hidden-lg-up';

    var label = document.createElement('span');
    label.className = 'sb-mobile-sort-label';
    label.textContent = 'Ordenar por';

    var select = source.cloneNode(true);
    select.id = 'SbMobileSortToolbar';
    select.className = 'sb-mobile-sort-select';
    select.setAttribute('aria-label', 'Ordenar productos');
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (select.value) {
        url.searchParams.set('sort_by', select.value);
      } else {
        url.searchParams.delete('sort_by');
      }
      window.location.assign(url.toString());
    });

    wrapper.appendChild(label);
    wrapper.insertAdjacentHTML('beforeend', caretIcon());
    wrapper.appendChild(select);
    toolbar.appendChild(wrapper);
  }

  function setMobileGridDefault() {
    if (!mobileMedia.matches) return;

    var container = document.getElementById('ProductGridContainer');
    if (container && container.getAttribute('data-sb-mobile-grid-ready') !== 'true') {
      if (container.getAttribute('data-sb-view') !== '1') {
        container.setAttribute('data-sb-view', '2');
      }
      container.setAttribute('data-sb-mobile-grid-ready', 'true');
    }

    var toolbar = document.querySelector('.collection-filters');
    if (!toolbar) return;

    var twoColumns = toolbar.querySelector('.column-2');
    var controls = toolbar.querySelectorAll('.collection-view-item, .collectiongrid-layout');
    for (var i = 0; i < controls.length; i += 1) {
      var isSelected = controls[i] === twoColumns;
      controls[i].classList.toggle('grid-layout-default', isSelected);
      controls[i].setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    }
  }

  function mobileStock(card, fallbackText) {
    var exactQuantity = parseInt(card.getAttribute('data-sb-qty'), 10);

    if (!Number.isNaN(exactQuantity)) {
      if (exactQuantity <= 0) return { text: 'Sin stock', state: 'is-alert' };
      if (exactQuantity === 1) return { text: 'Solo queda 1 unidad', state: 'is-alert' };
      return { text: 'Disponibles, ' + exactQuantity + ' unidades', state: 'is-available' };
    }

    var compact = String(fallbackText || '').replace(/\s+/g, ' ').trim();
    if (/sin stock/i.test(compact)) return { text: 'Sin stock', state: 'is-alert' };
    if (/confirmación/i.test(compact) || /^1\s*UND$/i.test(compact)) {
      return { text: 'Solo queda 1 unidad', state: 'is-alert' };
    }

    var match = compact.match(/(\d+)\+?\s*UND/i);
    if (match) {
      return {
        text: 'Disponibles, ' + match[1] + (compact.indexOf('+') > -1 ? '+ unidades' : ' unidades'),
        state: 'is-available'
      };
    }

    return { text: compact || 'Consultar disponibilidad', state: 'is-available' };
  }

  function enhanceCard(card) {
    if (!card) return;

    var promo = card.querySelector('.sbp-badge--promo');
    var discount = card.getAttribute('data-sb-discount');
    if (!discount || discount === '0') {
      var discountNode = card.querySelector('.sbp-discount');
      var match = discountNode && discountNode.textContent.match(/(\d+)%/);
      discount = match ? match[1] : '';
    }
    if (promo && discount) {
      var badgeText = 'Ahorrar ' + discount + '%';
      if (promo.textContent.trim() !== badgeText) promo.textContent = badgeText;
    }

    var title = card.querySelector('.sbp-title');
    var sku = card.querySelector('.sbp-sku');
    if (title && sku && !card.querySelector('.sbp-mobile-sku')) {
      var mobileSku = document.createElement('div');
      mobileSku.className = 'sbp-mobile-sku';
      mobileSku.textContent = sku.textContent.replace(/\s+/g, ' ').trim();
      title.insertAdjacentElement('afterend', mobileSku);
    }

    var addButton = card.querySelector('.sbp-add');
    if (addButton && !addButton.disabled &&
        addButton.getAttribute('data-sb-mobile-label') !== 'true') {
      addButton.textContent = 'Añadir al carrito';
      addButton.setAttribute('data-sb-mobile-label', 'true');
    }

    var stock = card.querySelector('.sbp-stock-label:not(.sbp-stock-label--mobile)');
    if (stock && !card.querySelector('.sbp-stock-label--mobile')) {
      stock.classList.add('sbp-stock-label--desktop');
      var mapped = mobileStock(card, stock.textContent);
      var mobileLabel = document.createElement('span');
      mobileLabel.className = 'sbp-stock-label sbp-stock-label--mobile ' + mapped.state;
      mobileLabel.textContent = mapped.text;
      stock.insertAdjacentElement('afterend', mobileLabel);
    }

    card.setAttribute('data-sb-mobile-card-ready', 'true');
  }

  function enhanceCards(root) {
    var cards = (root || document).querySelectorAll('.sbp-card');
    for (var i = 0; i < cards.length; i += 1) {
      enhanceCard(cards[i]);
    }
  }

  function enhanceWarehouseMobile() {
    ensureWarehouseStyles();
    if (!isCollectionExperience()) return;

    document.body.classList.add('sb-warehouse-mobile-view');

    var toolbar = document.querySelector('.collection-filters');
    if (toolbar) {
      enhanceFilterButton(toolbar);
      buildMobileSort(toolbar);
    }

    setMobileGridDefault();
    enhanceCards(document);
  }

  function scheduleEnhancement() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      enhanceWarehouseMobile();
    });
  }

  function startObserver() {
    if (observer || !document.documentElement) return;
    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleEnhancement();
          return;
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  ensureWarehouseStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhanceWarehouseMobile();
      startObserver();
    }, { once: true });
  } else {
    enhanceWarehouseMobile();
    startObserver();
  }

  document.addEventListener('shopify:section:load', scheduleEnhancement);
  window.addEventListener('pageshow', scheduleEnhancement);

  if (mobileMedia.addEventListener) {
    mobileMedia.addEventListener('change', scheduleEnhancement);
  } else if (mobileMedia.addListener) {
    mobileMedia.addListener(scheduleEnhancement);
  }
}());
